<template>
      <form-popover
        v-if="showConfirmation"
        :open="showConfirmation"
        :buttons="showSuccess ? { close: 'Close' } : {}"
        :processing="processing"
        :processing-message="processingMessage"
        @close="closePopup">
    <smooth-reflow class="flex items-center justify-center">
      <div v-if="reservation">
        <h1 class="text-aba-blue">Thank you for your reservation!</h1>
        <h1 class='title mt-base'>{{data.title}}</h1>
        <div class='date mt-sm'>{{data.formattedDate}}</div>
        <div class='date'>{{data.location}}</div>
        <p class="mt-base text-aba-blue">See you there!</p>
      </div>
    </smooth-reflow>
  </form-popover>
</template>

<script>
import FormPopover from './FormPopover'
import SmoothReflow from '../UI/SmoothReflow'
import { functions } from '../../../lib/firebase'
export default {
  name: 'ReservationConfirm',
  components: { SmoothReflow, FormPopover },
  props: {
    eventId: { type: String, required: true },
    data: { type: Object, required: true }
  },

  data: () => ({
    reservation: null,
    processing: false,
    processingMessage: 'Confirming reservation...',
    showSuccess: false
  }),

  computed: {
    showConfirmation () {
      return !!this.$route.params.token
    }
  },

  created () { if (this.$route.params.token) this.confirmReservation() },

  methods: {
    async confirmReservation () {
      if (!this.$route.params.token) {
        console.error('No token in route params:', this.$route.params)
        this.processingMessage = 'Confirmation token not found in URL'
        return
      }
      if (!this.eventId) {
        console.error('No eventId prop:', this.eventId)
        this.processingMessage = 'Event ID not found'
        return
      }
      this.processing = true
      try {
        console.log('Confirming reservation with:', {
          eventId: this.eventId,
          token: this.$route.params.token,
          routeParams: this.$route.params
        })
        // Use camelCase to match the exported function name (reservationConfirm)
        const confirmReservation = functions.httpsCallable('reservationConfirm', {
          timeout: 30000 // 30 second timeout
        })
        this.reservation = await confirmReservation({
          eventId: this.eventId,
          token: this.$route.params.token
        })
        console.log('Reservation confirmed:', this.reservation)
        this.processing = false
        this.showSuccess = true
        // Auto-close after 3 seconds
        setTimeout(() => {
          this.closePopup()
        }, 3000)
      } catch (error) {
        console.error('Error confirming reservation:', error)
        const errorMessage = error.message || error.details || 'Failed to confirm reservation. Please try again.'
        this.processingMessage = errorMessage
        // Keep processing true to show error message
        setTimeout(() => {
          this.processing = false
        }, 5000)
      } finally {
        // Don't set processing to false here if there was an error
        // Let the setTimeout handle it
        if (!this.processingMessage.includes('Failed') && !this.processingMessage.includes('not found')) {
          this.processing = false
        }
      }
    },
    closePopup () {
      // Remove token from URL to close the popup
      const newRoute = { ...this.$route }
      delete newRoute.params.token
      this.$router.replace({
        name: 'event',
        params: { id: this.eventId }
      })
    }
  }
}
</script>

<style lang="scss">
  .reservation-confirm-popover {
  }
</style>
